const map = {
	"./blue_core_work.json": 26498,
	"./instance.json": 85671,
	"./instance_with_refs.json": 63587,
	"./invalid_instance.json": 24059,
	"./invalid_rt.json": 87754,
	"./test-inputs.json": 76054,
	"./test-multiple_property_uris.json": 91301,
	"./test.json": 30408,
	"./test2.json": 17010,
	"./untagged_inputs.json": 41729,
	"./untagged_suppress_language.json": 30850,
	"./untagged_typed_literal.json": 80200,
	"./work_with_refs.json": 31345
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10567;